import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { List } from 'devextreme-react/list'

import './error-panel.scss'


type IErrorPanelProps = {
    err?: any,
}

export const ErrorPanel = ({ err }: IErrorPanelProps) => {
    const { t } = useTranslation()
    
    return (
        <div className='error-panel'>
            <p style={{ whiteSpace: 'pre-line' }}>{t(err) || 'Oops! Something bad happened'}</p>
        </div>
    )
}

type IPopupErrorPanelProps = {
    prefix?: string,
    err?: string | any,
}

export const PopupErrorPanel = ({ prefix, err }: IPopupErrorPanelProps) => {
    const className = useMemo(() => {
        const baseClassName = 'popup-error-panel error-panel'
        if (err === undefined) { return baseClassName }

        const types = err.map((e: any) => e.type)
        if (types.indexOf('error') !== -1) {
            return `${baseClassName} bg-error`
        } else if (types.indexOf('warning') !== -1) {
            return `${baseClassName} bg-warning`
        } else {
            return baseClassName
        }
    }, [err])

    const items = useMemo(() => {
        const items: any[] = []

        if (err) {
            const errors = err.filter((e: any) => e.type === 'error')
            if (errors.length) { items.push({ key: 'Errors', items: errors }) }

            const warnings = err.filter((e: any) => e.type === 'warning')
            if (warnings.length) { items.push({ key: 'Warnings', items: warnings }) }

            const infos = err.filter((e: any) => e.type === 'info')
            if (infos.length) { items.push({ key: 'Info', items: infos }) }
        }

        return items
    }, [err])

    if (err === undefined) {
        return null
    }

    return (
        <div className={ className }>
            <p style={ { margin: '0px' } }>
                { prefix ? (<b>{prefix}: </b>) : null }
            </p>
            <List
                items={items}
                displayExpr='msg'
                grouped={ true }
                hoverStateEnabled={ false }
                focusStateEnabled={ false }
                activeStateEnabled={ false }
                elementAttr={ { style: 'color: black !important;' } }
            />
        </div>
    )
}
